import {
  supabaseAuthService,
  supabaseLeaseService,
  supabaseApplicationService,
  supabaseCommunityService,
  supabaseMeetingService,
  supabaseLotService,
  supabaseLeaseholderService,
  supabaseLotLeaseSummaryService,
  supabaseUnderLeaseService,
  supabaseSubleaseService
} from './supabase';
import { supabase } from '../lib/supabase';
import type { DevFinancial } from '../types/financial';

export const api = {
  auth: supabaseAuthService,

  leases: {
    getAll: () => supabaseLeaseService.getAll(),
    getById: (id: string) => supabaseLeaseService.getById(id),
    getSubleaseIds: () => supabaseLeaseService.getSubleaseIds(),
    getAllEnhanced: () => supabaseLeaseService.getAllEnhanced()
  },
  
  subleases: {
    getAll: () => supabaseSubleaseService.getAll(),
    getById: (id: number) => supabaseSubleaseService.getById(id),
    getSubleaseIds: () => supabaseSubleaseService.getSubleaseIds()
  },

  lotLeaseSummary: {
    getAll: () => supabaseLotLeaseSummaryService.getAll(),
    getByLotId: (lotId: string) => supabaseLotLeaseSummaryService.getByLotId(lotId),
    getByCommunity: (communityCode: string) => supabaseLotLeaseSummaryService.getByCommunity(communityCode),
    create: supabaseLotLeaseSummaryService.create,
    update: supabaseLotLeaseSummaryService.update
  },

  applications: {
    getAll: () => supabaseApplicationService.getAll(),
    create: supabaseApplicationService.create,
    update: supabaseApplicationService.update
  },

  communities: {
    getAll: () => supabaseCommunityService.getAll()
  },

  meetings: {
    getAll: () => supabaseMeetingService.getAll()
  },

  lots: {
    getAll: () => supabaseLotService.getAll(),
    getById: (id: string) => supabaseLotService.getById(id),
    getByCommunity: (communityCode: string) => supabaseLotService.getByCommunity(communityCode),
    getAvailable: () => supabaseLotService.getAvailable()
  },

  leaseholders: {
    getAll: () => supabaseLeaseholderService.getAll(),
    getById: (id: number) => supabaseLeaseholderService.getById(id)
  },

  financials: {
    getAll: async () => {
      try {
        console.log('Fetching financial data...');
        const { data, error } = await supabase
          .from('dev_financials')
          .select('*')
          .order('created_at', { ascending: false });

        if (error) {
          console.error('Supabase error:', error);
          throw error;
        }

        console.log('Financial data:', data);
        return data as unknown as DevFinancial[];
      } catch (error) {
        console.error('Error fetching financial data:', error);
        throw error;
      }
    }
  },

  underleases: {
    getAll: () => supabaseUnderLeaseService.getAll(),
    create: supabaseUnderLeaseService.create,
    update: supabaseUnderLeaseService.update
  }
};
